// This file is auto-generated by @hey-api/openapi-ts

import { client } from './client.gen.js';
import type { Client, Options as Options2, TDataShape } from './client/index.js';
import type { CandidatesAwaitingSchoolResponseApiV1AnalyticsSchoolsAwaitingResponsePostData, CandidatesAwaitingSchoolResponseApiV1AnalyticsSchoolsAwaitingResponsePostErrors, CandidatesAwaitingSchoolResponseApiV1AnalyticsSchoolsAwaitingResponsePostResponses, CreateActionApiUserAuthV1ActionPostData, CreateActionApiUserAuthV1ActionPostErrors, CreateActionApiUserAuthV1ActionPostResponses, CreateActionApiV1ActionPostData, CreateActionApiV1ActionPostErrors, CreateActionApiV1ActionPostResponses, ExpressInterestApiUserAuthV1MatchesExpressInterestPostData, ExpressInterestApiUserAuthV1MatchesExpressInterestPostErrors, ExpressInterestApiUserAuthV1MatchesExpressInterestPostResponses, GenerateCandidatePreferenceWeightsApiUserAuthV1RecommendationCandidatePreferenceWeightsPostData, GenerateCandidatePreferenceWeightsApiUserAuthV1RecommendationCandidatePreferenceWeightsPostErrors, GenerateCandidatePreferenceWeightsApiUserAuthV1RecommendationCandidatePreferenceWeightsPostResponses, GenerateRecommendationsForCandidateApiUserAuthV1RecommendationCandidateGeneratePostData, GenerateRecommendationsForCandidateApiUserAuthV1RecommendationCandidateGeneratePostErrors, GenerateRecommendationsForCandidateApiUserAuthV1RecommendationCandidateGeneratePostResponses, GetCandidateCountsApiUserAuthV1RecommendationCandidateCountsGetData, GetCandidateCountsApiUserAuthV1RecommendationCandidateCountsGetErrors, GetCandidateCountsApiUserAuthV1RecommendationCandidateCountsGetResponses, GetCandidateInvitationsApiUserAuthV1InvitationsGetData, GetCandidateInvitationsApiUserAuthV1InvitationsGetErrors, GetCandidateInvitationsApiUserAuthV1InvitationsGetResponses, GetCandidateRecommendationsEndpointApiUserAuthV1RecommendationCandidateGetData, GetCandidateRecommendationsEndpointApiUserAuthV1RecommendationCandidateGetErrors, GetCandidateRecommendationsEndpointApiUserAuthV1RecommendationCandidateGetResponses, GetCandidatesActivityApiServiceAuthV1RecommendationCandidatesActivityPostData, GetCandidatesActivityApiServiceAuthV1RecommendationCandidatesActivityPostErrors, GetCandidatesActivityApiServiceAuthV1RecommendationCandidatesActivityPostResponses, GetConnectionsApiUserAuthV1ConnectionsCandidateGetData, GetConnectionsApiUserAuthV1ConnectionsCandidateGetErrors, GetConnectionsApiUserAuthV1ConnectionsCandidateGetResponses, GetConnectionsCountApiUserAuthV1ConnectionsCountGetData, GetConnectionsCountApiUserAuthV1ConnectionsCountGetErrors, GetConnectionsCountApiUserAuthV1ConnectionsCountGetResponses, GetInvitationsCountApiUserAuthV1InvitationsCountGetData, GetInvitationsCountApiUserAuthV1InvitationsCountGetErrors, GetInvitationsCountApiUserAuthV1InvitationsCountGetResponses, GetMatchStatusApiUserAuthV1MatchesStatusPostData, GetMatchStatusApiUserAuthV1MatchesStatusPostErrors, GetMatchStatusApiUserAuthV1MatchesStatusPostResponses, GetQuizQuestionsApiUserAuthV1QuizQuestionsGetData, GetQuizQuestionsApiUserAuthV1QuizQuestionsGetErrors, GetQuizQuestionsApiUserAuthV1QuizQuestionsGetResponses, GetQuizStatusApiUserAuthV1QuizStatusGetData, GetQuizStatusApiUserAuthV1QuizStatusGetErrors, GetQuizStatusApiUserAuthV1QuizStatusGetResponses, GetSchoolMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdMatchesGetData, GetSchoolMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdMatchesGetErrors, GetSchoolMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdMatchesGetResponses, GetSchoolResolvedMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdResolvedMatchesGetData, GetSchoolResolvedMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdResolvedMatchesGetErrors, GetSchoolResolvedMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdResolvedMatchesGetResponses, SaveResponseApiUserAuthV1QuizResponsesPostData, SaveResponseApiUserAuthV1QuizResponsesPostErrors, SaveResponseApiUserAuthV1QuizResponsesPostResponses, SchoolsApiV1AnalyticsSchoolsPostData, SchoolsApiV1AnalyticsSchoolsPostErrors, SchoolsApiV1AnalyticsSchoolsPostResponses, SummaryApiV1AnalyticsSummaryPostData, SummaryApiV1AnalyticsSummaryPostErrors, SummaryApiV1AnalyticsSummaryPostResponses } from './types.gen.js';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get School Matches
 *
 * Returns active matches awaiting school review.
 */
export const getSchoolMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdMatchesGet = <ThrowOnError extends boolean = true>(options: Options<GetSchoolMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdMatchesGetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSchoolMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdMatchesGetResponses, GetSchoolMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdMatchesGetErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/recommendation/school/{school_nces_id}/matches',
        ...options
    });
};

/**
 * Get School Resolved Matches
 *
 * Returns matches the school has already acted on.
 */
export const getSchoolResolvedMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdResolvedMatchesGet = <ThrowOnError extends boolean = true>(options: Options<GetSchoolResolvedMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdResolvedMatchesGetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSchoolResolvedMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdResolvedMatchesGetResponses, GetSchoolResolvedMatchesEndpointApiV1RecommendationSchoolSchoolNcesIdResolvedMatchesGetErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/recommendation/school/{school_nces_id}/resolved-matches',
        ...options
    });
};

/**
 * Create Action
 */
export const createActionApiV1ActionPost = <ThrowOnError extends boolean = true>(options: Options<CreateActionApiV1ActionPostData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateActionApiV1ActionPostResponses, CreateActionApiV1ActionPostErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/action/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Summary
 */
export const summaryApiV1AnalyticsSummaryPost = <ThrowOnError extends boolean = true>(options: Options<SummaryApiV1AnalyticsSummaryPostData, ThrowOnError>) => {
    return (options.client ?? client).post<SummaryApiV1AnalyticsSummaryPostResponses, SummaryApiV1AnalyticsSummaryPostErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/analytics/summary',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Schools
 */
export const schoolsApiV1AnalyticsSchoolsPost = <ThrowOnError extends boolean = true>(options: Options<SchoolsApiV1AnalyticsSchoolsPostData, ThrowOnError>) => {
    return (options.client ?? client).post<SchoolsApiV1AnalyticsSchoolsPostResponses, SchoolsApiV1AnalyticsSchoolsPostErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/analytics/schools',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Candidates Awaiting School Response
 */
export const candidatesAwaitingSchoolResponseApiV1AnalyticsSchoolsAwaitingResponsePost = <ThrowOnError extends boolean = true>(options: Options<CandidatesAwaitingSchoolResponseApiV1AnalyticsSchoolsAwaitingResponsePostData, ThrowOnError>) => {
    return (options.client ?? client).post<CandidatesAwaitingSchoolResponseApiV1AnalyticsSchoolsAwaitingResponsePostResponses, CandidatesAwaitingSchoolResponseApiV1AnalyticsSchoolsAwaitingResponsePostErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/analytics/schools/awaiting-response',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Generate Recommendations For Candidate
 *
 * Generate personalized school recommendations for a candidate.
 *
 * Uses pre-stored preference weights and the TRex evaluation pipeline
 * to produce a ranked list of schools tailored to candidate preferences.
 * Creates Matching records in the database for the selected schools.
 */
export const generateRecommendationsForCandidateApiUserAuthV1RecommendationCandidateGeneratePost = <ThrowOnError extends boolean = true>(options: Options<GenerateRecommendationsForCandidateApiUserAuthV1RecommendationCandidateGeneratePostData, ThrowOnError>) => {
    return (options.client ?? client).post<GenerateRecommendationsForCandidateApiUserAuthV1RecommendationCandidateGeneratePostResponses, GenerateRecommendationsForCandidateApiUserAuthV1RecommendationCandidateGeneratePostErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/user-auth/v1/recommendation/candidate/generate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Generate Candidate Preference Weights
 */
export const generateCandidatePreferenceWeightsApiUserAuthV1RecommendationCandidatePreferenceWeightsPost = <ThrowOnError extends boolean = true>(options: Options<GenerateCandidatePreferenceWeightsApiUserAuthV1RecommendationCandidatePreferenceWeightsPostData, ThrowOnError>) => {
    return (options.client ?? client).post<GenerateCandidatePreferenceWeightsApiUserAuthV1RecommendationCandidatePreferenceWeightsPostResponses, GenerateCandidatePreferenceWeightsApiUserAuthV1RecommendationCandidatePreferenceWeightsPostErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/user-auth/v1/recommendation/candidate/preference-weights',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Candidate Recommendations Endpoint
 */
export const getCandidateRecommendationsEndpointApiUserAuthV1RecommendationCandidateGet = <ThrowOnError extends boolean = true>(options: Options<GetCandidateRecommendationsEndpointApiUserAuthV1RecommendationCandidateGetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetCandidateRecommendationsEndpointApiUserAuthV1RecommendationCandidateGetResponses, GetCandidateRecommendationsEndpointApiUserAuthV1RecommendationCandidateGetErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/user-auth/v1/recommendation/candidate',
        ...options
    });
};

/**
 * Get Candidate Counts
 */
export const getCandidateCountsApiUserAuthV1RecommendationCandidateCountsGet = <ThrowOnError extends boolean = true>(options: Options<GetCandidateCountsApiUserAuthV1RecommendationCandidateCountsGetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetCandidateCountsApiUserAuthV1RecommendationCandidateCountsGetResponses, GetCandidateCountsApiUserAuthV1RecommendationCandidateCountsGetErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/user-auth/v1/recommendation/candidate/counts',
        ...options
    });
};

/**
 * Create Action
 */
export const createActionApiUserAuthV1ActionPost = <ThrowOnError extends boolean = true>(options: Options<CreateActionApiUserAuthV1ActionPostData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateActionApiUserAuthV1ActionPostResponses, CreateActionApiUserAuthV1ActionPostErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/user-auth/v1/action/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Candidate Invitations
 */
export const getCandidateInvitationsApiUserAuthV1InvitationsGet = <ThrowOnError extends boolean = true>(options: Options<GetCandidateInvitationsApiUserAuthV1InvitationsGetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetCandidateInvitationsApiUserAuthV1InvitationsGetResponses, GetCandidateInvitationsApiUserAuthV1InvitationsGetErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/user-auth/v1/invitations/',
        ...options
    });
};

/**
 * Get Invitations Count
 */
export const getInvitationsCountApiUserAuthV1InvitationsCountGet = <ThrowOnError extends boolean = true>(options: Options<GetInvitationsCountApiUserAuthV1InvitationsCountGetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetInvitationsCountApiUserAuthV1InvitationsCountGetResponses, GetInvitationsCountApiUserAuthV1InvitationsCountGetErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/user-auth/v1/invitations/count',
        ...options
    });
};

/**
 * Get Connections Count
 */
export const getConnectionsCountApiUserAuthV1ConnectionsCountGet = <ThrowOnError extends boolean = true>(options: Options<GetConnectionsCountApiUserAuthV1ConnectionsCountGetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetConnectionsCountApiUserAuthV1ConnectionsCountGetResponses, GetConnectionsCountApiUserAuthV1ConnectionsCountGetErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/user-auth/v1/connections/count',
        ...options
    });
};

/**
 * Get Connections
 */
export const getConnectionsApiUserAuthV1ConnectionsCandidateGet = <ThrowOnError extends boolean = true>(options: Options<GetConnectionsApiUserAuthV1ConnectionsCandidateGetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetConnectionsApiUserAuthV1ConnectionsCandidateGetResponses, GetConnectionsApiUserAuthV1ConnectionsCandidateGetErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/user-auth/v1/connections/candidate',
        ...options
    });
};

/**
 * Get candidate quiz status and responses
 */
export const getQuizStatusApiUserAuthV1QuizStatusGet = <ThrowOnError extends boolean = true>(options: Options<GetQuizStatusApiUserAuthV1QuizStatusGetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetQuizStatusApiUserAuthV1QuizStatusGetResponses, GetQuizStatusApiUserAuthV1QuizStatusGetErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/user-auth/v1/quiz/status',
        ...options
    });
};

/**
 * Get quiz questions for candidate
 */
export const getQuizQuestionsApiUserAuthV1QuizQuestionsGet = <ThrowOnError extends boolean = true>(options: Options<GetQuizQuestionsApiUserAuthV1QuizQuestionsGetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetQuizQuestionsApiUserAuthV1QuizQuestionsGetResponses, GetQuizQuestionsApiUserAuthV1QuizQuestionsGetErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/user-auth/v1/quiz/questions',
        ...options
    });
};

/**
 * Save candidate quiz responses
 */
export const saveResponseApiUserAuthV1QuizResponsesPost = <ThrowOnError extends boolean = true>(options: Options<SaveResponseApiUserAuthV1QuizResponsesPostData, ThrowOnError>) => {
    return (options.client ?? client).post<SaveResponseApiUserAuthV1QuizResponsesPostResponses, SaveResponseApiUserAuthV1QuizResponsesPostErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/user-auth/v1/quiz/responses',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Match Status
 */
export const getMatchStatusApiUserAuthV1MatchesStatusPost = <ThrowOnError extends boolean = true>(options: Options<GetMatchStatusApiUserAuthV1MatchesStatusPostData, ThrowOnError>) => {
    return (options.client ?? client).post<GetMatchStatusApiUserAuthV1MatchesStatusPostResponses, GetMatchStatusApiUserAuthV1MatchesStatusPostErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/user-auth/v1/matches/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Express Interest
 */
export const expressInterestApiUserAuthV1MatchesExpressInterestPost = <ThrowOnError extends boolean = true>(options: Options<ExpressInterestApiUserAuthV1MatchesExpressInterestPostData, ThrowOnError>) => {
    return (options.client ?? client).post<ExpressInterestApiUserAuthV1MatchesExpressInterestPostResponses, ExpressInterestApiUserAuthV1MatchesExpressInterestPostErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/user-auth/v1/matches/express_interest',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Candidates Activity
 */
export const getCandidatesActivityApiServiceAuthV1RecommendationCandidatesActivityPost = <ThrowOnError extends boolean = true>(options: Options<GetCandidatesActivityApiServiceAuthV1RecommendationCandidatesActivityPostData, ThrowOnError>) => {
    return (options.client ?? client).post<GetCandidatesActivityApiServiceAuthV1RecommendationCandidatesActivityPostResponses, GetCandidatesActivityApiServiceAuthV1RecommendationCandidatesActivityPostErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/api/service-auth/v1/recommendation/candidates/activity',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
